import { SPACING } from '@alto/design-library-tokens';
import React from 'react';
import styled from 'styled-components';

const getSize = ({ $size, sidebar }: { $size?: number; sidebar?: boolean }) => {
  if ($size) return `${$size}px`;
  return sidebar ? '80px' : '120px';
};

const Img = styled.img<{ sidebar?: boolean; center?: boolean; $size?: number }>`
  width: ${getSize};
  height: ${getSize};
  margin: 0 auto ${({ sidebar }) => (sidebar ? 0 : SPACING.STATIC.SM.rem)};
  ${({ center }) =>
    center &&
    `
    display: flex;
    text-align: center;
  `}
`;

type Props = {
  readonly src: string;
  readonly alt: string;
  readonly sidebar?: boolean;
  readonly center?: boolean;
  readonly size?: number;
};

export const Image: React.FC<Props> = ({ alt, center, src, sidebar, size }) => {
  return (
    <Img
      center={center}
      src={src}
      alt={alt || ''}
      sidebar={sidebar}
      $size={size}
    />
  );
};
